import { render } from "./CheckPayment.vue?vue&type=template&id=21f90fba&scoped=true"
import script from "./CheckPayment.vue?vue&type=script&lang=js"
export * from "./CheckPayment.vue?vue&type=script&lang=js"

import "./CheckPayment.vue?vue&type=style&index=0&id=21f90fba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21f90fba"]])

export default __exports__